<template>
  <div id="signed" style="margin: 50px 0">
    <table width="100%">
      <tr>
        <td width="50%" style="padding-right: 100px; vertical-align: top">
          <p><strong>Yours sincerely,</strong></p>
          <p v-if="bindSignature === false" style="margin-bottom: 121px !important"></p>
          <p v-if="bindSignature !== false" style="margin-bottom: 36px !important">
            <img id="sale-person-signature" height="80px" alt="Signature" :src="bindSignature">
          </p>
          <p>{{binSalePersonFullName}}</p>
          <p>{{bindData(specialOfferDetail, 'salePerson.position', '')}}</p>
        </td>
        <td width="50%" style="padding-left: 100px; vertical-align: top">
          <p style="margin-bottom: 121px !important"><strong>Accepted by</strong></p>
          <p style="margin-bottom: 6px !important;">
            <span class="helping-tag" v-if="isTemplate">Contact Name</span>
            <span v-else> {{getContactName}} </span>
          </p>
          <p>
            <span class="helping-tag" v-if="isTemplate">Contact Position</span>
            <span v-else>{{ getContactPosition}}</span>
          </p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { SPECIAL_OFFER_REF_CODE_TYPE, SPECIAL_OFFER_STATUS, STATUS } from '@/configs/constant'
import { bindData } from '@/helpers'
import { get } from 'lodash'

export default {
  name: 'SignedComponent',
  props: {
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {
          autoRefCode: STATUS.DISABLE,
          status: SPECIAL_OFFER_STATUS.DRAFT,
          refCode: '',
          refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
          hotel: {
            id: '',
            information: {
              code: '',
              name: ''
            },
            salePerson: {
              id: '',
              title: '',
              firstName: '',
              lastName: '',
              position: '',
              email: '',
              updatedAt: ''
            }
          },
          promotion: {
            promotion: {
              id: '',
              code: '',
              detail: '',
              minNight: 0,
              maxNight: 0,
              isEnable: 0,
              updatedAt: 0,
              bookingPeriod: {
                startDate: '',
                endDate: ''
              },
              periodOfStayList: [],
              isEnableAllotment: 0,
              roomTypeList: []
            }
          },
          agentList: [],
          general: {
            startDate: '',
            endDate: '',
            issueDate: '',
            internalNote: '',
            footerMessage: '',
            bodyMessage: ''
          }
        }
      }
    },
    isTemplate: {
      type: Boolean,
      default: true
    },
    agent: {
      type: Object,
      default: () => {
        return {
          name: '',
          information: {
            address: '',
            country: '',
            emailList: [],
            faxList: [],
            phoneList: [],
            zipCode: ''
          },
          contactPerson: {
            emailList: [],
            firstName: '',
            lastName: '',
            title: '',
            position: ''
          }
        }
      }
    }
  },
  data () {
    return {
      bindData
    }
  },
  computed: {
    binSalePersonFullName: function () {
      const salePerson = get(this.specialOfferDetail, 'hotel.salePerson', {})
      const title = get(salePerson, 'title', '')
      const firstName = get(salePerson, 'firstName', '')
      const lastName = get(salePerson, 'lastName', '')

      return `${title} ${firstName} ${lastName}`
    },
    getContactName: function () {
      const title = get(this.agent, 'contactPerson.title', '')
      const firstName = get(this.agent, 'contactPerson.firstName', '')
      const lastName = get(this.agent, 'contactPerson.lastName', '')

      const fullName = `${title}${firstName} ${lastName}`
      if (fullName.trim() === '') {
        return '-'
      }

      return fullName
    },
    getContactPosition: function () {
      const position = get(this.agent, 'contactPerson.position', '-')

      return position
    },
    bindSignature: function () {
      const isAddSignature = Boolean(get(this.specialOfferDetail, 'hotel.salePerson.isAddSignature', 0))
      const signatureUrl = get(this.specialOfferDetail, 'hotel.salePerson.signatureUrl', '')

      if (isAddSignature === true && signatureUrl !== '') {
        return signatureUrl
      }

      return false
    }
  }
}
</script>

<style scoped>
  .helping-tag {
    background-color: #78C0D8;
    color: #ffffff;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 15px;
    font-size: 15px;
  }
</style>
